export default "__VITE_ASSET__3818de0c__"